<template>
    <nav class="tabs dashboard-tabs is-fullwidth">
        <div class="container">
            <ul>
                <li :class="[page == 1 ? 'is-active':'has-text-white']">
                    <router-link to="/cuenta/personajes">
                        <span class="icon is-small"><fa icon="users" /></span>
                        <span>Personajes</span>
                    </router-link>
                </li>
                <li :class="[page == 4 ? 'is-active':'has-text-white']">
                    <router-link to="/cuenta/vip">
                        <span class="icon is-small"><fa icon="award" /></span>
                        <span>VIP</span>
                    </router-link>
                </li>
                <li :class="[page == 3 ? 'is-active':'has-text-white']">
                    <router-link to="/cuenta/banco">
                        <span class="icon is-small"><fa icon="coins" /></span>
                        <span>Banca Web</span>
                    </router-link>
                </li>
                <li :class="[page == 5 ? 'is-active':'has-text-white']">
                    <router-link to="/cuenta/actividad" >
                        <span class="icon is-small"><fa icon="rss" /></span>
                        <span>Actividad</span>
                    </router-link>
                </li>
                <!-- <li :class="{'is-active':page == 9}">
                    <a @click="$store.commit('changeDashboardPage', 9)">
                        <span class="icon is-small"><fa icon="address-card" /></span>
                        <span>Mis Datos</span>
                    </a>
                </li> -->
            </ul>
        </div>
    </nav>
</template>

<script>
export default {
    name:'DashboardNavbar',
    props: {
        page: {
            default: 1,
            type:Number
        }
    }
}
</script>

<style scoped>
    .tabs {
        white-space: inherit !important;
    }
</style>